<template>
<div class="container" style="background-color: #EFFBEF">
  <div class="my-Header">
    <my-Header @search-click="searchClick"></my-Header>
  </div>
  <div class="my-Navigation">
    <my-Navigation :navList="navList" :subList="subList" :class="{fixed:isFixed}"></my-Navigation>
  </div>

  <div class="Banner">
    <my-Banner :bannerList="bannerList"></my-Banner>
  </div>
  <div class="Tans">
    <my-Tans />
  </div>
  <div class="home">
    <my-Neck :newList="newList"></my-Neck>
    <div class="boy top" >
      <my-TabsOne :midList="midList[0]"></my-TabsOne>
       <my-TabsOne :midList="midList[1]"></my-TabsOne>
        <my-TabsOne :midList="midList[2]"></my-TabsOne>
    </div>
    <div class="boy top">
    <my-TabsOne :midList="midList[3]"></my-TabsOne>
    <my-TabsOne :midList="midList[4]"></my-TabsOne>
    <my-TabsOne :midList="midList[5]"></my-TabsOne>
  </div>
  </div>
  <div class="boy home top" >
    <my-TabsOne :midList="midList[6]"></my-TabsOne>
    <my-TabsOne :midList="midList[7]"></my-TabsOne>
    <div class="TabsOne">
      <my-TabsTwo style="margin-bottom: 11px" :midList="midList[8]"></my-TabsTwo>
      <my-TabsTwo :midList="midList[9]"></my-TabsTwo>
    </div>
  </div>
  <div class="Carousel home top">
    <my-Carousel :imgList="dwList"></my-Carousel>
  </div>

  <div class="End top">
    <my-End></my-End>
  </div>
</div>
</template>

<script>
import End from '@/components/End'
import Header from '@/components/Headr'
import Bannner from '@/components/Banner'
import Navigation from '@/components/Navigation'
import Neck from '@/components/Neck'
import Carousel from '@/components/Carousel'
import TabsOne from '@/components/Tabs1'
import TabsTwo from '@/components/Tabs2'
import CutImg from '@/components/CutImg'
import Topic from '@/components/Topic'
import Tans from '@/components/HomeTabs-right'
import axios from "axios";
import { orgId, requestUrl } from '../common/cons'
export default {
name: "Home",
  components:{
    'my-Header':Header,
    'my-End':End,
    'my-Banner':Bannner,
    'my-Navigation':Navigation,
    'my-Neck':Neck,
    'my-Carousel': Carousel,
    'my-TabsOne': TabsOne,
    'my-TabsTwo': TabsTwo,
    'my-CutImg':CutImg,
    'my-Topic':Topic,
    'my-Tans':Tans
  },
  data(){
  return{
    isFixed:false,
    bannerList:[],
    navList:[],
    subList:[],
    midList:[],
    newList:[],
    imgList:[],
    zlList:[],
    dwList:[]
  }
  },
  async created(){
   await this.init()
  },
  methods:{
  async init(){
    await this.queryBannerList()
    await this.queryNavList()
    await this.queryNewList()
    await this.queryMidList()
    await this.queryImgList()
    await this.queryZlList()
    await this.querydwList()
  },
    async queryNavList(){
      const result = await axios.get(`${requestUrl}/nav/${orgId}`)
      this.navList = result.data
      const idList = []
      this.navList.forEach((item, index) => {
        idList.push(item.colmun_id)
      })
      const subList = await axios.get(`${requestUrl}/dnjt/nav/column?idList=${idList}`)
      subList.data.forEach(item => {
        this.subList.push(item)
      })
    },
    async queryBannerList(){
      const result = await axios.get(`${requestUrl}/banner/getBannerList?bannerTitle=banner-z&orgId=${orgId}`)
      result.data.forEach((item, index) => {
        if (item.img === '' || item.img === null) {
          result.data.splice(index, 1)
        }
      })
      this.bannerList = result.data
    },
    async queryNewList(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=new&orgId=${orgId}`)
      this.newList=newData.data
    },
    async queryMidList(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=mid&orgId=${orgId}`)
      this.midList=newData.data
    },
    async queryImgList(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=img&orgId=${orgId}`)
      this.imgList=newData.data
    },
    async queryZlList(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=zl&orgId=${orgId}`)
      this.zlList=newData.data
    },
    async querydwList(){
      const newData=await axios.get(`${requestUrl}/news/getNewsList?blockCode=zr-dw&orgId=${orgId}`)
      this.dwList=newData.data
    },

    handleScroll(e){
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop>20){
        this.isFixed=true;
      }else {
        this.isFixed=false
      }
    },
    searchClick (keywords) {
      this.$router.push({
        path: '/news/515',
        query: {
          keywords: keywords
        }
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },destroyed() {
    document.removeEventListener('scroll', this.handleScroll)
  }



}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}
.boy{
  display: flex;
  justify-content: space-between;
  flex-direction:row;
  flex-wrap: wrap;
}
.TabsOne{
  display: flex;
  flex-direction: column;
}
.fixed{
  position: fixed;
  top: 0;
  z-index: 999;
}
.home{
  width: 1200px;
  margin: 0 auto;
}
.top{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue